export default __webpack_public_path__ + "static/media/doctorClipboard.fbcead19.jpg";